<template>
    <div class="pdf-app-wrapper">
        <vue-pdf-app
            :pdf="path"
            theme="light"
            page-scale="page-fit"
        />
    </div>
</template>

<script>
import 'vue-pdf-app/dist/icons/main.css'
import VuePdfApp from 'vue-pdf-app'

export default {
    name: 'View.vue',
    data () {
        return {}
    },
    components: {
        VuePdfApp
    },
    computed: {
        path () {
            return decodeURIComponent(this.$route.query.path || '')
        }
    }
}
</script>

<style scoped>
.pdf-app-wrapper {
    height: 100vh;
    width: 100%;
}
</style>
